// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/productivity-salaries/requests",
  Create: "/pyr/productivity-salaries/requests",
  Update: "/pyr/productivity-salaries/requests",
  Detail: "/pyr/productivity-salaries/requests",
  Approve: "/pyr/productivity-salaries/requests/approve",
  AllowRequest: "/pyr/productivity-salaries/allow-summary-request",
};
